/////////////////////////////////////////
// IMPORT
/////////////////////////////////////////
import { equal } from 'junctions-fp'
/**
 * Utilitaire permettant de facilement savoir si l'event keyboard a pour origin le canvas ou non,
 * ainsi que des alias pour des touches en particuliers (ctrl, shift etc...)
 * @class KeyUtils
 */
class KeyUtils {
  /**
   * Creates an instance of KeyUtils.
   * @param {KeyboardEvent}  this.event Un event de type KeyboardEvent
   * @example new KeyUtils(event)
   */
  constructor(event) {
    this.event = event
  }
  /////////////////////////////////////////
  // METHODS
  /////////////////////////////////////////
  /**
   *  Vérifie si la touche qui a emit l'évènement est bien égale à la valeur
   *  Attention nous verifie toute les touche en lowercase
   * @param {any} value
   */
  isKey(value) {
    return equal(this.getKey(), value.toLowerCase())
  }
  /**
   *  Retourne la valeur de la clé
   *  Attention nous verifie toute les touche en lowercase
   * @param {any} value
   */
  getKey() {
    return this.event.key.toLowerCase()
  }
  /**
   * La touche shift est/ou a été pressé
   *
   * @readonly
   */
  get isShift() {
    return this.event.shiftKey
  }
  /**
   * La touche control est/ou a été pressé
   *
   * @readonly
   */
  get isControl() {
    return this.event.ctrlKey
  }
  /**
   * La touche cmd de mac est/ou a été pressé
   *
   * @readonly
   */
  get isMeta() {
    return this.event.metaKey
  }
  /**
   *  La touche suppr ou backspace est/ou a été pressé
   *
   * @readonly
   */
  get isDeleteBack() {
    return equal(this.event.key, 'Delete') || equal(this.event.key, 'Backspace')
  }

  /**
   * L'event est envoyé depuis le body et non depuis un element du dom
   *
   * @readonly
   */
  get fromCanvas() {
    return equal(this.event.target.nodeName, 'BODY')
  }
  /////////////////////////////////////////
  // GETTERS / SETTERS
  /////////////////////////////////////////
}
export default KeyUtils



// WEBPACK FOOTER //
// ./src/model/pixel/tools/KeyUtils.js